import { render } from "./AlumnesTransport.vue?vue&type=template&id=06dadf03&scoped=true"
import script from "./AlumnesTransport.vue?vue&type=script&lang=js"
export * from "./AlumnesTransport.vue?vue&type=script&lang=js"

import "./AlumnesTransport.vue?vue&type=style&index=0&id=06dadf03&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dadf03"]])

export default __exports__